import { memo } from "react";
import { useTranslation } from "react-i18next";

// UI components
import Icon from "components/Icon";
import Checkbox from "components/Checkbox";

const TableBody = ({
  tableData,
  columns,
  currentPage,
  pageLimit,
  isOrgLevel,
  checkedRows,
  handleCheck,
  isManagerPrivilege,
}) => {
  const { t } = useTranslation();

  const TableWithData = () => {
    const datafetchPage = !isOrgLevel ? 1 : currentPage;
    const startIndex = 0;

    return (
      <tbody>
        {tableData
          .slice(
            (datafetchPage - 1) * pageLimit,
            (datafetchPage - 1) * pageLimit + pageLimit
          )
          .map((data, index, array) => {
            return (
              <tr key={data.id}>
                <td>
                  <Checkbox
                    id={data.id}
                    checked={checkedRows[startIndex + index]}
                    disabled={!isManagerPrivilege}
                    onChange={() => {
                      handleCheck(index, data.id, array.length);
                    }}
                  />
                </td>
                <td>{(currentPage - 1) * pageLimit + index + 1}</td>
                {columns.map(({ accessor }) => {
                  const tData = data[accessor] ? data[accessor] : "";
                  return accessor === "licenseStatus" ||
                    accessor === "licenseState" ? (
                    <td key={accessor}>{t(tData)}</td>
                  ) : accessor === "onlineStatus" ? (
                    <td key={accessor}>
                      <Icon className={`icon-round ${tData}`} />
                    </td>
                  ) : (
                    <td key={accessor}>{tData}</td>
                  );
                })}
              </tr>
            );
          })}
      </tbody>
    );
  };

  const TableWithoutData = () => {
    return (
      <tbody>
        <tr>
          <td colSpan="10" style={{ textAlign: "center", height: 35 }}>
            {t("ad01242a61")}
          </td>
        </tr>
      </tbody>
    );
  };

  return <>{tableData.length > 0 ? <TableWithData /> : <TableWithoutData />}</>;
};

export default memo(TableBody);
